import styled from 'styled-components';
import { buttonBase } from '../styled';
import { getButtonSize, getButtonAppearance } from '../utils';
import { getLoaderSize } from '../utils/getLoaderSize';
import { stretchButton } from '../utils/stretchButton';
export const Button = styled.button `
  ${buttonBase};
  ${stretchButton};

  ${(props) => getButtonSize(props.size)};
  ${(props) => getLoaderSize(props.size)};
  ${(props) => getButtonAppearance(props.appearance)};
`;
